import { FileSizeUnitEnum, isResultError } from '../types';
/**
 * Contributions service
 */
class DocumentsService {
    documentsAdapter;
    constructor({ documentsAdapter }) {
        this.documentsAdapter = documentsAdapter;
    }
    /**
     * Get document data as blob type
     *
     * @param documentHref - Document link in GED
     */
    async getDocumentAsBlob(documentHref) {
        const result = await this.documentsAdapter.getDocumentAsBlob(documentHref);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Downloads document from its GED path
     *
     * @param documentHref - Document GED path
     */
    async getDownloadUrl(documentHref) {
        const documentData = await this.getDocumentAsBlob(documentHref);
        const document = new Blob([documentData], {
            type: documentData.type === 'application/octet-stream' ? 'application/pdf' : documentData.type,
        });
        return URL.createObjectURL(document);
    }
    /**
     * Converts a document size to human-readable size
     *
     * @param documentSize - Size of document in bytes
     * @returns size with biggest unit
     */
    formatToHumanReadableSize(documentSize) {
        const unitIndex = documentSize === 0 ? 0 : Math.floor(Math.log(documentSize) / Math.log(1024));
        const units = Object.values(FileSizeUnitEnum);
        return {
            size: Number.parseFloat((documentSize / Math.pow(1024, unitIndex)).toFixed(2)),
            unit: units[unitIndex] ?? FileSizeUnitEnum.BYTE,
        };
    }
}
export { DocumentsService };
//# sourceMappingURL=documents-service.js.map